var _Path, _Path2, _Path3, _Path4, _Path5, _Path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path, Rect } from "react-native-svg";
var SvgUpdatesAtGlance = function SvgUpdatesAtGlance(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 158 79"
  }, props), /*#__PURE__*/React.createElement(Path, {
    fill: props.fillLine,
    d: "M108.8 5.8a2 2 0 0 1 2.7-1L156.3 27a2 2 0 0 1 1 2.6l-23.5 47.6a2 2 0 0 1-2.6.9l-44.9-22a2 2 0 0 1-1-2.7z",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement(Rect, {
    width: 53,
    height: 56,
    x: 107.9,
    y: 2.7,
    fill: props.accentFillLine,
    stroke: props.fillLine,
    rx: 1.5,
    transform: "rotate(26.2 107.9 2.7)"
  }), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#BCBCBC",
    fillRule: "evenodd",
    d: "m122.4 36.6.3.3v.4l-.4.5h.7l.5.3v.6l-.2.1h-.9l.4.6v.4l-.2.4h-.4l-.3-.2-.4-.6-.3.6-.3.3-.6-.4v-.4l.3-.6h-.7l-.5-.2V38l.2-.1h.2l.7-.1-.4-.6V37q0-.3.2-.4h.4q.2 0 .3.2l.4.6.3-.6.3-.3zM117 40q0-.2.3-.2h.4l4.7 2.5q.2 0 .3.3v.4l-.3.2h-.4l-4.8-2.5-.3-.3zm-1 1.8.3-.2h.4l4.8 2.5.3.3v.4l-.4.2h-.4l-4.7-2.5-.3-.3z",
    clipRule: "evenodd"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    fill: "#BCBCBC",
    d: "m119.5 30.5 9.5 4.9q.8.4 1.1 1.2.2.7-.1 1.6l-5.6 11a2 2 0 0 1-1.3 1l-1.6-.2-9.5-5q-.8-.3-1-1.2a2 2 0 0 1 0-1.5l.5-1 1 .5-.5 1v.7q0 .4.5.7L122 49h.8q.5 0 .6-.5l5.6-11 .1-.7-.5-.6-9.5-5a1 1 0 0 0-.9 0l-.6.5-.4 1-1-.6.5-.9a2 2 0 0 1 1.2-1q.8-.1 1.6.2"
  })), _Path3 || (_Path3 = /*#__PURE__*/React.createElement(Path, {
    fill: "#BCBCBC",
    d: "m115.3 34 .2-.4.3-.3a.5.5 0 0 1 .7.4v.4l-.3.4.5.3.3.3v.4l-.4.2h-.4l-1.9-1-.2-.3.3-.6h.4zm-1.4 2.8.2-.5.3-.2a.5.5 0 0 1 .7.3v.4l-.3.5.5.2.3.3v.4l-.4.3h-.4l-1.9-1-.2-.4.3-.6h.4zm-1.4 2.7.2-.4q0-.2.3-.3a.5.5 0 0 1 .7.4v.4l-.3.4.5.3q.2 0 .2.3v.4l-.3.2h-.4l-1.9-1-.3-.3a.5.5 0 0 1 .4-.7h.4z"
  })), /*#__PURE__*/React.createElement(Path, {
    fill: props.fillLine,
    d: "M2.6 24a2 2 0 0 1 1.3-2.6l47.7-15A2 2 0 0 1 54 7.5l16 50.6a2 2 0 0 1-1.3 2.5L21 75.7a2 2 0 0 1-2.5-1.3z",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement(Rect, {
    width: 53,
    height: 56,
    x: 0.6,
    y: 20.3,
    fill: props.accentFillLine,
    stroke: props.fillLine,
    rx: 1.5,
    transform: "rotate(-17.5 .6 20.3)"
  }), _Path4 || (_Path4 = /*#__PURE__*/React.createElement(Path, {
    fill: "#BCBCBC",
    fillRule: "evenodd",
    d: "M26.6 33.9A2.5 2.5 0 0 0 25 37l2.5 7.7a2.5 2.5 0 0 0 3 1.6l3-1h.3l3.4 1.8 1.7-3.3.3-.3 2.8-.9a2.5 2.5 0 0 0 1.6-3.1l-2.4-7.6a2.5 2.5 0 0 0-3.1-1.7zm-2.3.8q.6-1.4 2-1.8l11.5-3.6a3.5 3.5 0 0 1 4.4 2.3l2.4 7.6a3.5 3.5 0 0 1-2.3 4.4l-2.6.8-1.9 3.6q-.2.5-.7.2l-3.5-1.8-2.7.8a3.5 3.5 0 0 1-4.4-2.2l-2.4-7.7q-.4-1.4.2-2.6m5.1 3q0-.4.4-.6l7.6-2.4a.5.5 0 1 1 .3 1L30 38q-.5.1-.7-.3m1.3 3.8q-.2-.4.3-.6l5.7-1.8a.5.5 0 1 1 .3 1l-5.7 1.8q-.5 0-.6-.4",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement(Path, {
    fill: props.fillLine,
    d: "M52.9 4q.2-1.8 2-2h50a2 2 0 0 1 2 2v53a2 2 0 0 1-2 2h-50a2 2 0 0 1-2-2z",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement(Rect, {
    width: 53,
    height: 56,
    x: 51.4,
    y: 0.5,
    fill: props.accentFillLine,
    stroke: props.fillLine,
    rx: 1.5
  }), _Path5 || (_Path5 = /*#__PURE__*/React.createElement(Path, {
    fill: "#BCBCBC",
    fillRule: "evenodd",
    d: "M73 18q.5 0 .5.5v1.8h7.2a.5.5 0 0 1 0 1h-7.2v1.9a.5.5 0 0 1-1 0v-4.7q0-.5.5-.5m10.8 0q.4 0 .5.5v1.8h2.6a2 2 0 0 1 2 2v14.8a2 2 0 0 1-2 2h-17a2 2 0 0 1-2-2V22.4a2 2 0 0 1 2-2 .5.5 0 1 1 0 1l-.7.2-.3.8V37q0 .5.3.8l.7.3h17l.7-.3q.3-.3.3-.8V22.4l-.3-.8-.7-.3h-2.6v1.9a.5.5 0 0 1-1 0v-4.7q0-.5.5-.5",
    clipRule: "evenodd"
  })), _Path6 || (_Path6 = /*#__PURE__*/React.createElement(Path, {
    fill: "#BCBCBC",
    fillRule: "evenodd",
    d: "M76.2 24.7q.4-.4 1-.4h2.4a1.3 1.3 0 0 1 1.3 1.3v1.7h1.7a1.3 1.3 0 0 1 1.2 1.2V31a1.3 1.3 0 0 1-1.2 1.3h-1.7V34a1.3 1.3 0 0 1-1.3 1.3h-2.5A1.3 1.3 0 0 1 76 34v-1.7h-1.7A1.3 1.3 0 0 1 73 31v-2.5a1.3 1.3 0 0 1 1.3-1.2H76v-1.7q0-.6.3-1m1 .6H77l-.1.3v2.2q-.1.4-.5.5H74v2.9l.2.1h2.2q.4 0 .5.5v2.4h2.9l.1-.2v-2.2q0-.5.5-.5h2.4v-3h-2.4l-.5-.5v-2.4l-.3-.1z",
    clipRule: "evenodd"
  })));
};
export default SvgUpdatesAtGlance;